import { z } from 'zod';
import { uuidV7Schema } from './ids';
import { calendarBookingStateSchema } from './action-recovery';
export const agendaItemSchema = z
  .object({
    actionId: uuidV7Schema,
    conversationId: uuidV7Schema,
    createdAt: z.iso.datetime({ offset: true }),
    subject: z.string(),
    adviserName: z.string().nullable(),
    booking: calendarBookingStateSchema.nullable(),
    checkedAt: z.iso.datetime({ offset: true }).nullable(),
    synchronizationRequired: z.boolean(),
    error: z.string().nullable(),
  })
  .strict();
export type AgendaItem = z.infer<typeof agendaItemSchema>;
export const agendaSchema = z
  .object({
    appointments: z.array(agendaItemSchema),
    nextCursor: uuidV7Schema.nullable(),
  })
  .strict();
